const Modals = (props) => {
	return props.children
}

export default Modals
